export const initialState = {
  featureFlags: {},
};
